import { Transition } from "@headlessui/react"
import { CloseIcon } from "../assets/CommonIcons"
import { CurrencyIcon } from "../assets/ImvIcons"

export const FiltersDrawer = ({ show, setIsDrawerOpen }) => {
    return (<>
        <Transition appear show={show}>
            <section className="fixed min-h-screen min-w-screen w-full bg-[#0004] backdrop-blur-lg z-50">
                <Transition.Child
                    as='div'
                    enter="transform transition ease-in-out duration-500"
                    enterFrom="translate-x-[-100%]"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-[-100%]"
                >
                    <article className="w-96 bg-[#1d4aa7] flex flex-col space-y-10 min-h-screen rounded-r-xl p-10">
                        <header className="flex items-center w-full">
                            <button onClick={() => setIsDrawerOpen(false)} className="h-10">
                                <CloseIcon />
                            </button>
                        </header>

                        <div className="grid gap-y-10 w-full min-h-full row-span-6">

                            <FilterField icon={<CurrencyIcon />} field={'Valor'}>
                                <div>
                                    Valores
                                </div>
                            </FilterField>
                            <FilterField icon={<CurrencyIcon />} field={'Bairro'}>

                            </FilterField>

                        </div>

                    </article>

                </Transition.Child>

            </section>
        </Transition>
    </>)
}

const FilterField = ({ icon, field, children }) => {
    return (<>
        <article className="border p-5 rounded">
            <span className="flex items-center justify-start h-10">
                <span className="h-7 aspect-square">
                    {icon}
                </span>
                <h2 className="capitalize">
                    {field}
                </h2>
            </span>

            {children}

        </article>
    </>)
}